import React from 'react';

import { Block, withGridConfig } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Column } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { default as Image } from '../common/Image.jsx';
import { ContentContainer } from '../common/List.jsx';
import Name from '../common/Name.jsx';
import * as SearchResultCell from './SearchResultCell.jsx';
import { Tab, TabsContainer } from '../common/Tab.jsx';
import Token from '../common/Token.jsx';
import Utilities from '../common/Utilities.jsx';

// region LIST

function _SearchResultsList(props) {
    let logoImageUrl;
    if (props.config && props.config.logo) {
        logoImageUrl = Image.url(props.config.logo);
    }
    let data = [];
    let q;
    if (props.data && props.data.search) {
        data = props.data.search.results || [];
        q = props.data.search.q;
    }
    let artists, blogs, inventory, shows;
    const useTabs = props.blockConfig && props.blockConfig.tabs && props.blockConfig.tabs.useTabs == true;
    if (useTabs) {
        artists = [];
        blogs = [];
        inventory = [];
        shows = [];
    }
    const isArtist = props.config && props.config.userType == 1;
    const [activeTab, setActiveTab] = React.useState(undefined);
    let count = 0;
    let results = [];
    data.forEach((d, i) => {
        let contentConfig;
        switch (d.type) {
            case SearchResultCell.SearchResultType.Artist:
                if (useTabs) {
                    artists.push(d);
                    if (activeTab != undefined && activeTab != SearchResultCell.SearchResultType.Artist) {
                        return;
                    }
                }
                if (props.blockConfig.block && props.blockConfig.block.artistCell && props.blockConfig.block.artistCell.desktop && props.blockConfig.block.artistCell.desktop.blocks && props.blockConfig.block.artistCell.desktop.blocks.length > 0) {
                    contentConfig = props.blockConfig.block.artistCell;
                } else {
                    contentConfig = Defaults.Block[Name.Block.SearchResult.List].ArtistCell(props.config);
                }
                break;
            case SearchResultCell.SearchResultType.Blog:
                if (useTabs) {
                    blogs.push(d);
                    if (activeTab != undefined && activeTab != SearchResultCell.SearchResultType.Blog) {
                        return;
                    }
                }
                if (props.blockConfig.block && props.blockConfig.block.blogCell && props.blockConfig.block.blogCell.desktop && props.blockConfig.block.blogCell.desktop.blocks && props.blockConfig.block.blogCell.desktop.blocks.length > 0) {
                    contentConfig = props.blockConfig.block.blogCell;
                } else {
                    contentConfig = Defaults.Block[Name.Block.SearchResult.List].BlogCell(props.config);
                }
                break;
            case SearchResultCell.SearchResultType.Inventory:
                if (useTabs) {
                    inventory.push(d);
                    if (activeTab != undefined && activeTab != SearchResultCell.SearchResultType.Inventory) {
                        return;
                    }
                }
                if (props.blockConfig.block && props.blockConfig.block.inventoryCell && props.blockConfig.block.inventoryCell.desktop && props.blockConfig.block.inventoryCell.desktop.blocks && props.blockConfig.block.inventoryCell.desktop.blocks.length > 0) {
                    contentConfig = props.blockConfig.block.inventoryCell;
                } else {
                    contentConfig = Defaults.Block[Name.Block.SearchResult.List].InventoryCell(props.config);
                }
                break;
            case SearchResultCell.SearchResultType.Show:
                if (useTabs) {
                    shows.push(d);
                    if (activeTab != undefined && activeTab != SearchResultCell.SearchResultType.Show) {
                        return;
                    }
                }
                if (props.blockConfig.block && props.blockConfig.block.showCell && props.blockConfig.block.showCell.desktop && props.blockConfig.block.showCell.desktop.blocks && props.blockConfig.block.showCell.desktop.blocks.length > 0) {
                    contentConfig = props.blockConfig.block.showCell;
                } else {
                    contentConfig = Defaults.Block[Name.Block.SearchResult.List].ShowCell(props.config);
                }
                break;
        }
        results.push(
            <Column key={i} size={props.columnSize}>
                <SearchResultCell.SearchResultCellContainer
                    {...props}
                    contentConfig={contentConfig}
                    data={d}
                    index={count}
                    isArtist={isArtist}
                    listData={data}
                    logoImageUrl={logoImageUrl} />
            </Column>
        );
        count++;
    });
    if (results.length == 0) {
        let resultType = 'results';
        switch (activeTab) {
            case SearchResultCell.SearchResultType.Artist:
                resultType = 'artists';
                break;
            case SearchResultCell.SearchResultType.Blog:
                resultType = 'blogs';
                break;
            case SearchResultCell.SearchResultType.Inventory:
                resultType = 'inventory';
                break;
            case SearchResultCell.SearchResultType.Show:
                resultType = 'exhibitions';
                break;
        }
        results = <div>No {resultType} matching your search term{q ? `: ${q}` : ''}</div>
    }
    if (useTabs) {
        let styleTabs = {};
        let styleTabsContainer = {}
        Block.mapStyleConfigProps(styleTabs, props.blockConfig.tabs, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'alignment':
                    return true;
                case 'maxWidth':
                    if (propValue && propUnit) {
                        styleTabsContainer = { maxWidth: `${propValue}${propUnit}` };
                    }
                    return true;
            }
        });
        styleTabsContainer = Block.updateAlignment(styleTabsContainer, props.blockConfig.tabs.alignmentContainer);

        let headerContent = (
            <TabsContainer builder={props.builder}>
                <Tab
                    active={activeTab == undefined}
                    className="tab__link--search"
                    display={`All${props.data ? ` (${data.length})` : ''}`}
                    value={undefined}
                    onClick={setActiveTab} />
                {
                    !isArtist &&
                    <Tab
                        active={activeTab == SearchResultCell.SearchResultType.Artist}
                        anchorName="artists"
                        className="tab__link--search"
                        display={`Artists${props.data ? ` (${artists.length})` : ''}`}
                        value={SearchResultCell.SearchResultType.Artist}
                        onClick={setActiveTab} />
                }
                <Tab
                    active={activeTab == SearchResultCell.SearchResultType.Blog}
                    anchorName="blogs"
                    className="tab__link--search"
                    display={`Blogs${props.data ? ` (${blogs.length})` : ''}`}
                    value={SearchResultCell.SearchResultType.Blog}
                    onClick={setActiveTab} />
                <Tab
                    active={activeTab == SearchResultCell.SearchResultType.Inventory}
                    anchorName="inventory"
                    className="tab__link--search"
                    display={`Inventory${props.data ? ` (${inventory.length})` : ''}`}
                    value={SearchResultCell.SearchResultType.Inventory}
                    onClick={setActiveTab} />
                <Tab
                    active={activeTab == SearchResultCell.SearchResultType.Show}
                    anchorName="shows"
                    className="tab__link--search"
                    display={`Exhibitions${props.data ? ` (${shows.length})` : ''}`}
                    value={SearchResultCell.SearchResultType.Show}
                    onClick={setActiveTab} />
            </TabsContainer>
        );
        switch (props.blockConfig.tabs.alignment) {
            case 'left':
                headerContent = (
                    <React.Fragment>
                        {headerContent}
                        <div style={{ flex: 1 }} />
                    </React.Fragment>
                );
                break;
            case 'right':
                headerContent = (
                    <React.Fragment>
                        <div style={{ flex: 1 }} />
                        {headerContent}
                    </React.Fragment>
                );
                break;
            default:
                headerContent = (
                    <React.Fragment>
                        <div style={{ flex: 1 }} />
                        {headerContent}
                        <div style={{ flex: 1 }} />
                    </React.Fragment>
                );
                break;
        }
        const style = {};
        Utilities.copyObject(props.style, style);
        const wrapperStyle = {};
        if (style.marginLeft) {
            wrapperStyle.marginLeft = style.marginLeft;
            style.marginLeft = undefined;
        }
        if (style.marginRight) {
            wrapperStyle.marginRight = style.marginRight;
            style.marginRight = undefined;
        }
        if (style.paddingLeft) {
            wrapperStyle.paddingLeft = style.paddingLeft;
            style.paddingLeft = undefined;
        }
        if (style.paddingRight) {
            wrapperStyle.paddingRight = style.paddingRight;
            style.paddingRight = undefined;
        }
        return (
            <div className="cont--kit__wrapper" style={props.containerStyle}>
                <div className="cont--tabs__wrapper cont--kit__content" style={wrapperStyle}>
                    <div className="cont--tabs__controls" style={styleTabsContainer}>
                        <div className="tabs__wrapper" style={styleTabs}>
                            {headerContent}
                        </div>
                    </div>
                    <div className="cont--tabs__content" style={style}>
                        <ContentContainer type="search">
                            {results}
                        </ContentContainer>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="cont--kit__wrapper" style={props.containerStyle}>
            <ContentContainer className="cont--kit__content" style={props.style} type="search">
                {results}
            </ContentContainer>
        </div>
    );
}
const SearchResultsList = withGridConfig(_SearchResultsList, 1);
const List = { Component: SearchResultsList };

// region SEARCH TERM

function _MetaComponent(props) {
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className="cont--kit__content" style={layoutStyles.style}>
                    <div className="cont cont--token" dangerouslySetInnerHTML={{ __html: props.content }}></div>
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const MetaComponent = Token.withContentTokenParsing(_MetaComponent, { extraParseConditionHandler: (props) => [props.data.search.q] }, (props, keyword) => {
    if (!props.data) {
        return undefined;
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Count:
            if (props.data.search && props.data.search.results) {
                replaceString = `${props.data.search.results.length}`;
            }
            break;
        case Token.SearchTerm:
            if (props.data.search && props.data.search.q && props.data.search.q.length > 0) {
                replaceString = props.data.search.q;
            } else if (props.builder) {
                replaceString = '[ search value ]';
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const MetaTokens = () => {
    return [
        { display: 'Search Term', token: Token.SearchTerm },
        { display: 'Result Count', token: Token.Count }
    ];
}
const Meta = { Component: MetaComponent, Tokens: MetaTokens };

export default { List, Meta };